<template>
	<v-container :fluid="fluid" grid-list-lg :fill-height="fillHeight">
		<v-fade-transition mode="out-in" appear>
			<router-view></router-view>
		</v-fade-transition>

		<!-- <v-btn color="pink" flat @click="addMessage()">Add</v-btn>-->
		<notifications></notifications>
	</v-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import Notifications from "@components/partials/Notifications";
var { fillHeight } = require("@root/mixins");

export default {
	mixins: [fillHeight],
	data() {
		return {};
	},

	components: {
		Notifications
	},

	computed: {
		...mapGetters(["messages", "fluid"])
	},

	methods: {
		...mapMutations("messages", ["ADD_MESSAGE"]),

		...mapActions("messages", {
			GET_MESSAGES: "getMessages"
		}),

		...mapActions("documents", {
			GET_DOCUMENTS: "getDocuments"
		}),

		addMessage() {
			this.ADD_MESSAGE({
				id: this.messages.length,
				text: "Testing " + this.messages.length,
				show: true
			});
		}
	},

	created() {
		this.GET_MESSAGES({ type: ["unread", "read"] });
		this.GET_DOCUMENTS({
			params: {
				orderby: "proposal_date"
			}
		});
	}
};
</script>
